/* tslint:disable:member-ordering */
export type CategoryItem = {
  name: string;
  bookingLabelKey: string;
  priceLabelKey?: string;
};

export type CategoryDefinition = {
  uuid: string;
  rank: number;
  bookingHeadingKey: string;
  bookingSubKey?: string;
  bookingSubLinkKey?: string;
  priceHeadingKey?: string;
  priceSubKey?: string;
  priceSubLinkKey?: string;
  items: CategoryItem[];
};

export const CATEGORY_DEFINITIONS: CategoryDefinition[] = [
  {
    uuid: 'Category-1',
    rank: 1,
    bookingHeadingKey: 'bookingFormTest_1',
    bookingSubKey: 'bookingFormTest_1_0_sub',
    bookingSubLinkKey: 'bookingFormTest_1_0_sublink',
    priceHeadingKey: 'price_1',
    priceSubKey: 'price_1_0_sub',
    priceSubLinkKey: 'price_1_0_sublink',
    items: [
      { name: 'O_VU', bookingLabelKey: 'bookingFormTest_1_1', priceLabelKey: 'price_1_1' },
      { name: 'O_VEGGIE', bookingLabelKey: 'bookingFormTest_1_2', priceLabelKey: 'price_1_2' },
      { name: 'O_SPORTB', bookingLabelKey: 'bookingFormTest_1_3', priceLabelKey: 'price_1_3' },
      { name: 'O_SPORTPLUS', bookingLabelKey: 'bookingFormTest_1_4', priceLabelKey: 'price_1_4' },
      { name: 'O_VITBAS', bookingLabelKey: 'bookingFormTest_1_5', priceLabelKey: 'price_1_5' },
      { name: 'O_VITPLUS', bookingLabelKey: 'bookingFormTest_1_6', priceLabelKey: 'price_1_6' },
      { name: 'O_HAARE', bookingLabelKey: 'bookingFormTest_1_7', priceLabelKey: 'price_1_7' },
      // { name: 'O_RESPI', bookingLabelKey: 'bookingFormTest_1_8', priceLabelKey: 'price_1_8' },
      // { name: 'O_COLAIQ', bookingLabelKey: 'bookingFormTest_1_9', priceLabelKey: 'price_1_9' },
      { name: 'O_STI', bookingLabelKey: 'bookingFormTest_1_10', priceLabelKey: 'price_1_10' },
      { name: 'O_STIPLUS', bookingLabelKey: 'bookingFormTest_1_11', priceLabelKey: 'price_1_11' },
    ],
  },
  {
    uuid: 'Category-2',
    rank: 3,
    bookingHeadingKey: 'bookingFormTest_2',
    priceHeadingKey: 'price_2',
    items: [
      { name: 'O_DROG', bookingLabelKey: 'bookingFormTest_2_1', priceLabelKey: 'price_2_1' },
      { name: 'O_CDT', bookingLabelKey: 'bookingFormTest_2_2', priceLabelKey: 'price_2_2' },
      { name: 'O_CDTPRO', bookingLabelKey: 'bookingFormTest_2_3', priceLabelKey: 'price_2_3' },
      { name: 'O_HIV', bookingLabelKey: 'bookingFormTest_2_4', priceLabelKey: 'price_2_4' },
      { name: 'O_HEPC', bookingLabelKey: 'bookingFormTest_2_5', priceLabelKey: 'price_2_5' },
      { name: 'O_DAO', bookingLabelKey: 'bookingFormTest_2_6', priceLabelKey: 'price_2_6' },
      { name: 'O_OMEGA', bookingLabelKey: 'bookingFormTest_2_7', priceLabelKey: 'price_2_7' },
      // { name: 'O_RESPI', bookingLabelKey: 'bookingFormTest_2_8', priceLabelKey: 'price_2_8' },
    ],
  },
  {
    uuid: 'Category-3',
    rank: 2,
    bookingHeadingKey: 'bookingFormTest_3',
    priceHeadingKey: 'price_3',
    items: [
      { name: 'O_FSMEIGG', bookingLabelKey: 'bookingFormTest_3_1', priceLabelKey: 'price_3_1' },
      { name: 'O_HAVAK', bookingLabelKey: 'bookingFormTest_3_2', priceLabelKey: 'price_3_2' },
      { name: 'O_HBSAK', bookingLabelKey: 'bookingFormTest_3_3', priceLabelKey: 'price_3_3' },
      { name: 'O_MASERN', bookingLabelKey: 'bookingFormTest_3_4', priceLabelKey: 'price_3_4' },
      { name: 'O_MUMPS', bookingLabelKey: 'bookingFormTest_3_5', priceLabelKey: 'price_3_5' },
      { name: 'O_ROET', bookingLabelKey: 'bookingFormTest_3_6', priceLabelKey: 'price_3_6' },
      { name: 'O_VZV', bookingLabelKey: 'bookingFormTest_3_7', priceLabelKey: 'price_3_7' },
      { name: 'covidABTest', bookingLabelKey: 'bookingFormTest_3_8', priceLabelKey: 'price_3_8' },
    ],
  },
  {
    uuid: 'Category-4',
    rank: 5,
    bookingHeadingKey: 'bookingFormTest_4',
    priceHeadingKey: 'price_4',
    items: [
      { name: 'O_VITA', bookingLabelKey: 'bookingFormTest_4_1', priceLabelKey: 'price_4_1' },
      { name: 'O_VITB1', bookingLabelKey: 'bookingFormTest_4_2', priceLabelKey: 'price_4_2' },
      { name: 'O_VITB2', bookingLabelKey: 'bookingFormTest_4_3', priceLabelKey: 'price_4_3' },
      { name: 'O_VITB3', bookingLabelKey: 'bookingFormTest_4_4', priceLabelKey: 'price_4_4' },
      { name: 'O_VB6', bookingLabelKey: 'bookingFormTest_4_5', priceLabelKey: 'price_4_5' },
      { name: 'O_FOL', bookingLabelKey: 'bookingFormTest_4_6', priceLabelKey: 'price_4_6' },
      { name: 'O_HOLOTC', bookingLabelKey: 'bookingFormTest_4_7', priceLabelKey: 'price_4_7' },
      { name: 'O_VB12', bookingLabelKey: 'bookingFormTest_4_8', priceLabelKey: 'price_4_8' },
      { name: 'O_VITC', bookingLabelKey: 'bookingFormTest_4_9', priceLabelKey: 'price_4_9' },
      { name: 'O_VITD', bookingLabelKey: 'bookingFormTest_4_10', priceLabelKey: 'price_4_10' },
      { name: 'O_VD2', bookingLabelKey: 'bookingFormTest_4_11', priceLabelKey: 'price_4_11' },
      { name: 'O_VITE', bookingLabelKey: 'bookingFormTest_4_12', priceLabelKey: 'price_4_12' },
      { name: 'O_VITK1', bookingLabelKey: 'bookingFormTest_4_13', priceLabelKey: 'price_4_13' },
      { name: 'O_VITK2', bookingLabelKey: 'bookingFormTest_4_14', priceLabelKey: 'price_4_14' },
      { name: 'O_UBI', bookingLabelKey: 'bookingFormTest_4_15', priceLabelKey: 'price_4_15' },
    ],
  },
  {
    uuid: 'Category-5',
    rank: 4,
    bookingHeadingKey: 'bookingFormTest_5',
    priceHeadingKey: 'price_5',
    items: [
      { name: 'O_NAV', bookingLabelKey: 'bookingFormTest_5_1', priceLabelKey: 'price_5_1' },
      { name: 'O_KV', bookingLabelKey: 'bookingFormTest_5_2', priceLabelKey: 'price_5_2' },
      { name: 'O_CAV', bookingLabelKey: 'bookingFormTest_5_3', priceLabelKey: 'price_5_3' },
      { name: 'O_MGV', bookingLabelKey: 'bookingFormTest_5_4', priceLabelKey: 'price_5_4' },
      { name: 'O_FEV', bookingLabelKey: 'bookingFormTest_5_5', priceLabelKey: 'price_5_5' },
      { name: 'O_SEV', bookingLabelKey: 'bookingFormTest_5_6', priceLabelKey: 'price_5_6' },
      { name: 'O_ZNV', bookingLabelKey: 'bookingFormTest_5_7', priceLabelKey: 'price_5_7' },
      { name: 'O_CUV', bookingLabelKey: 'bookingFormTest_5_8', priceLabelKey: 'price_5_8' },
      // { name: 'O_MINK', bookingLabelKey: 'bookingFormTest_5_9', priceLabelKey: 'price_5_9' },
      // { name: 'O_MINM', bookingLabelKey: 'bookingFormTest_5_10', priceLabelKey: 'price_5_10' },
      // { name: 'O_MINVB', bookingLabelKey: 'bookingFormTest_5_11', priceLabelKey: 'price_5_11' },
      { name: 'O_VMULTIK', bookingLabelKey: 'bookingFormTest_5_12', priceLabelKey: 'price_5_12' },
      { name: 'O_VMULTIP', bookingLabelKey: 'bookingFormTest_5_13', priceLabelKey: 'price_5_13' },
      { name: 'O_SMULTIK', bookingLabelKey: 'bookingFormTest_5_14', priceLabelKey: 'price_5_14' },
      { name: 'O_SMULTIP', bookingLabelKey: 'bookingFormTest_5_15', priceLabelKey: 'price_5_15' },
      { name: 'O_HMULTIK', bookingLabelKey: 'bookingFormTest_5_16', priceLabelKey: 'price_5_16' },
      { name: 'O_HMULTIP', bookingLabelKey: 'bookingFormTest_5_17', priceLabelKey: 'price_5_17' },
    ],
  },
];

export const ALL_TEST_CODES: string[] = CATEGORY_DEFINITIONS.flatMap(category =>
  category.items.map(item => item.name)
);
